<template>
    <Transition>
        <Glass v-if="open" class="top-[calc(100%+.5rem)] left-0 lg:-left-1/4 absolute w-[calc(100vw-1rem)] lg:w-3/2" padding="md">
            <div v-if="loading" class="flex justify-center items-center p-8 w-full text-primary">
                <Icon name="svg-spinners:3-dots-bounce" class="block size-8!" />
            </div>
            <div v-else-if="result?.products.length || result?.blogPosts.length || result?.categories.length">
                <WidgetProductList
                    @click="handleClick"
                    v-if="result?.products.length"
                    :products="result.products"
                    :columns="{ base: 3, lg: undefined, md: undefined }"
                />
            </div>
            <div v-else class="w-full">
                <div class="flex flex-col justify-center items-center p-8 text-gray-500 text-center">
                    <Icon name="mdi:magnify-remove-outline" class="mb-4 size-12!" />
                    <p class="font-medium text-lg">{{ $t("general.search_result.no_result_title") }}</p>
                    <p class="text-sm">{{ $t("general.search_result.no_result_description") }}</p>
                </div>
            </div>
        </Glass>
    </Transition>
</template>

<script lang="ts" setup>
import { WidgetProductList } from "#components";
import { Glass } from "@/components/ui/glass";

interface Props {
    open?: boolean;
    loading?: boolean;
    result?: APISearchResult;
}

defineProps<Props>();

const emit = defineEmits(["close"]);

function handleClick() {
    emit("close");
}
</script>

<style>
.v-enter-active,
.v-leave-active {
    transition:
        transform 0.3s ease,
        opacity 0.3s ease;
}

.v-enter-from {
    transform: translateY(-10px);
    opacity: 0;
}

.v-leave-to {
    transform: translateY(-10px);
    opacity: 0;
}
</style>
